const getModalState = state => state.modal
export const getModalContent = state => state.modalContent

export default getModalState
